<div class="page">
    <div class="title">
        <button class="buttonBack" (click)="irAUrlAnterior()"><mat-icon>arrow_back</mat-icon></button>
        <div class="titleValue">{{ "privacyPolicy.title" | transloco }}</div>
        <div class="line"></div>
    </div>

    <div class="content">
        <p>{{ "privacyPolicy.intro.p1" | transloco }}</p>

        <h3>{{ "privacyPolicy.contactInfo.title" | transloco }}</h3>
        <p>{{ "privacyPolicy.contactInfo.p1" | transloco }}</p>
        <ul>
            <li *ngFor="let item of ('privacyPolicy.contactInfo.contact' | transloco)" [innerHTML]="item"></li>
        </ul>

        <h3>{{ "privacyPolicy.dataProcessor.title" | transloco }}</h3>
        <p>{{ "privacyPolicy.dataProcessor.p1" | transloco }}</p>
        <ul>
            <li *ngFor="let item of ('privacyPolicy.dataProcessor.contact' | transloco)" [innerHTML]="item"></li>
        </ul>

        <h3>{{ "privacyPolicy.dataCollection.title" | transloco }}</h3>
        <p>{{ "privacyPolicy.dataCollection.p1" | transloco }}</p>

        <h3>{{ "privacyPolicy.purposes.title" | transloco }}</h3>
        <p>{{ "privacyPolicy.purposes.p1" | transloco }}</p>
        <ul>
            <li *ngFor="let item of ('privacyPolicy.purposes.list' | transloco)">{{item}}</li>
        </ul>

        <h3>{{ "privacyPolicy.recipients.title" | transloco }}</h3>
        <p>{{ "privacyPolicy.recipients.p1" | transloco }}</p>
        <ul>
            <li *ngFor="let item of ('privacyPolicy.recipients.list' | transloco)">{{item}}</li>
        </ul>

        <h3>{{ "privacyPolicy.retention.title" | transloco }}</h3>
        <p>{{ "privacyPolicy.retention.p1" | transloco }}</p>

        <h3>{{ "privacyPolicy.security.title" | transloco }}</h3>
        <p>{{ "privacyPolicy.security.p1" | transloco }}</p>

        <h3>{{ "privacyPolicy.rights.title" | transloco }}</h3>
        <p>{{ "privacyPolicy.rights.p1" | transloco }}</p>
        <p>{{ "privacyPolicy.rights.p2" | transloco }}</p>
        <p>{{ "privacyPolicy.rights.p3" | transloco }}</p>
        <p>{{ "privacyPolicy.rights.p4" | transloco }}</p>
        <p>{{ "privacyPolicy.rights.p5" | transloco }}</p>
        <p>{{ "privacyPolicy.rights.p6" | transloco }}</p>

        <h3>{{ "privacyPolicy.updates.title" | transloco }}</h3>
        <p>{{ "privacyPolicy.updates.p1" | transloco }}</p>
        <p>{{ "privacyPolicy.updates.p2" | transloco }}</p>
    </div>
</div>
